<template>
  <v-card
    class="mx-auto overflow-visible"
    width="800px"
    style="margin-top: 0px; margin-bottom: 0px;"
    outlined
  >
    <v-list-item three-line>
      <v-list-item-content class="overflow-visible">
        <v-row class="align-center">
          <v-col cols="12" md="6">
            <v-list-item-title class="display-2 mb-2">Lựa chọn cột hiển thị</v-list-item-title>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <v-icon aria-label="Close" @click="closeRowAttribute">mdi-close</v-icon>
          </v-col>
        </v-row>
        <v-divider style="margin-bottom: 28px;"></v-divider>
        <v-row>
          <template v-for="(attribute, index) in cloneCourseExtensionShowField">
            <v-col cols="12" md="3" class="pt-0 pb-0" :key="index">
              <v-checkbox class="ma-0" color="#E91E63" v-model="cloneCourseExtensionShowField[index]" :label="index" />
            </v-col>
          </template>
        </v-row>
        <v-divider style="margin-bottom: 20px;"></v-divider>
        <div class="text-center mb-4" style="display: flex; justify-content: flex-end">
          <v-btn class="mx-0"  style="margin-right: 10px !important;" @click="closeRowAttribute">Hủy</v-btn>
          <v-btn
            class="mx-0 base-theme-color"
            @click="applyRowAttribute"
          >Áp dụng</v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  props: {
    filterForm: {
      default: () => ({}),
    },
  },
  data() {
    return {
      cloneCourseExtensionShowField: null,
    };
  },
  computed: {
    ...mapState('student_care', ['courseExtensionShowField']),
    objectList() {
      return Object.keys(this.contactColumns);
    },
  },
  async created() {
    if (!this.courseExtensionShowField) {
      await this.getCourseExtensionShowField();
    }
    this.cloneCourseExtensionShowField = this.cloneDeep(this.courseExtensionShowField);
  },
  methods: {
    ...mapActions('student_care', ['getCourseExtensionShowField']),
    ...mapMutations('student_care', ['GET_COURSE_EXTENSION_SHOW_FIELD']),
    getObjectText(objectValue) {
      return objectValue;
    },
    cloneDeep(object) {
      return JSON.parse(JSON.stringify(object));
    },
    applyRowAttribute() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.openRowMenu = false;
      // Luu du lieu vao localStorage
      this.GET_COURSE_EXTENSION_SHOW_FIELD(this.cloneCourseExtensionShowField);
      localStorage.setItem('displayColumnsInExtension', JSON.stringify(this.cloneCourseExtensionShowField));
    },
    closeRowAttribute() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.openRowMenu = false;
    },
  },
};
</script>
